export enum AuthenticationTokenTypes {
  AccessToken = "combinum_access_token",        // used as parameter name, reflected in server in TokenManager
  WebSessionToken = "Web-Session-Token",  // used as header name, reflected in server in TokenManager
  TokenBySSO = "token_by_sso"
}